<template>
  <el-dialog :title="title" :visible.sync="formVisible" :close-on-click-modal="false" width="520px" append-to-body>
    <el-form ref="dataForm" :model="form" :rules="formRules" label-width="110px" size="small">
      <el-form-item label="已选商品：">
        <span>共 {{ goodsIdList.length }} 个商品</span>
      </el-form-item>
      <el-form-item label="平台标签：" prop="tagCodeList">
        <el-checkbox-group v-model="form.tagCodeList">
          <el-checkbox v-for="item in tagOptions" :key="item.key" :label="item.key">{{ item.value }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item v-if="mode !== 'cancel'" label="有效期：" prop="dateTime">
        <el-date-picker
          v-model="form.dateTime"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="生效时间"
          end-placeholder="失效时间"
          style="width: 100%"
        />
      </el-form-item>
      <!-- REQ-2026-470053：人工调整必须记录操作原因，事后在商品操作日志里能查到为什么改 -->
      <el-form-item label="操作原因：" prop="reason">
        <el-input
          v-model="form.reason"
          type="textarea"
          :rows="2"
          maxlength="200"
          show-word-limit
          placeholder="请填写本次人工调整的原因"
        />
      </el-form-item>
      <el-form-item v-if="mode !== 'cancel'">
        <span class="hint">标签只在有效期内生效；到期后自动失效，不会改变商品的上下架状态。</span>
      </el-form-item>
      <el-form-item v-else>
        <span class="hint">取消后该标签立即从APP商城的筛选结果里消失，商品的上下架状态不受影响。</span>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="formVisible = false">取消</el-button>
      <el-button type="primary" size="small" :loading="submitting" @click="doSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysGoodsPlatformTagApi from '@/api/goods/sysGoodsPlatformTag'

/**
 * 商品列表页的平台标签批量操作弹窗
 * mode: set=批量设置 adjust=批量调整有效期 cancel=批量取消
 */
export default {
  name: 'PlatformTagBatch',
  data() {
    return {
      formVisible: false,
      submitting: false,
      mode: 'set',
      goodsIdList: [],
      tagOptions: [],
      form: {
        tagCodeList: [],
        dateTime: [],
        reason: ''
      },
      formRules: {
        tagCodeList: [{ required: true, message: '请选择平台标签', trigger: 'change' }],
        dateTime: [{ required: true, message: '请选择有效期', trigger: 'change' }],
        // 原因必填：这是人工调整，方案要求「记录人工来源及操作原因」，
        // 留空就等于日志里只有"谁改的"没有"为什么改"，等于没记
        reason: [
          { required: true, message: '请填写操作原因', trigger: 'blur' },
          { max: 200, message: '操作原因不能超过200个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      if (this.mode === 'cancel') return '批量取消平台标签'
      if (this.mode === 'adjust') return '批量调整标签有效期'
      return '批量设置平台标签'
    }
  },
  created() {
    this.loadOptions()
  },
  methods: {
    loadOptions() {
      sysGoodsPlatformTagApi.options().then(({ data }) => {
        this.tagOptions = data || []
      })
    },
    open(mode, goodsIdList) {
      this.mode = mode
      this.goodsIdList = goodsIdList || []
      this.form = { tagCodeList: [], dateTime: [], reason: '' }
      if (!this.tagOptions.length) this.loadOptions()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doSubmit() {
      this.$refs['dataForm'].validate(valid => {
        if (!valid) return
        const params = {
          goodsIdList: this.goodsIdList,
          tagCodeList: this.form.tagCodeList,
          reason: this.form.reason
        }
        if (this.mode !== 'cancel') {
          const [effectiveAt, expiredAt] = this.form.dateTime || []
          // 后端也会校验一次，这里先挡一道，省一次往返
          if (!effectiveAt || !expiredAt) return this.$message.error('请选择有效期')
          if (effectiveAt >= expiredAt) return this.$message.error('生效时间必须早于失效时间')
          params.effectiveAt = effectiveAt
          params.expiredAt = expiredAt
        }
        const request = this.mode === 'cancel'
          ? sysGoodsPlatformTagApi.batchCancel(params)
          : (this.mode === 'adjust'
            ? sysGoodsPlatformTagApi.batchAdjust(params)
            : sysGoodsPlatformTagApi.batchSet(params))
        this.submitting = true
        request.then(() => {
          this.$message.success('操作成功')
          this.formVisible = false
          this.$emit('updated')
        }).finally(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.hint {
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
</style>
